import { LoginComponent } from './login.component';

export const containers = [LoginComponent];

export * from './login.component';
